import { createContext } from 'react';

export const TranslateContext = createContext({});